

import request from '@/utils/request'

export default {
  indexSearchByKey(data) {
    return request({
      url: '/dataindex/indexSearchByKey',
      method: 'post',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/indexsearch.js